export default __webpack_public_path__ + "static/media/Show-documentation.eb4dcf26.md";